import { BoundAutocomplete } from "lib/@components/binding/bound-components"

const UNIT_OF_MEASURE_OPTIONS = ["Unspecified", "System", "Nr", "m²", "Metre"]

export function UnitOfMeasureSelect({ sx, disabled } = {}) {
    return (
        <BoundAutocomplete
            sx={{ mt: 2, ...sx }}
            field="unitOfMeasure"
            label="Unit of Measure"
            options={UNIT_OF_MEASURE_OPTIONS}
            disableClearable
            disabled={disabled}
            isOptionEqualToValue={(option, value) => option === value}
        />
    )
}
